import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Divider
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { updateRoute } from 'src/store/actions/RouteManagerActions';

function UpdateRoute({ open, handleClose, item }) {
  const [loading, setLoading] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setCurrentItem(item);
  }, [item]);

  const handleRoute = async (values) => {
    setLoading(true);
    const response = await dispatch(updateRoute(item?.id, values));
    if (response == 1) {
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle id="title">
        <Typography color="textPrimary" variant="h3">
          Update Route
        </Typography>
      </DialogTitle>
      <Divider />
      <Formik
        initialValues={{
          route: `${currentItem?.route}`,
          datafull: `${currentItem?.datafull}`,
          // dataless: `${currentItem?.dataless}`,
          // failed: `${currentItem?.failed}`,
          id: `${currentItem?.id}`
        }}
        validationSchema={Yup.object().shape({
          route: Yup.string().trim().max(255).required('Route is required'),
          datafull: Yup.string().trim().max(255).required('User ID is required')
          // dataless: Yup.string()
          //   .trim()
          //   .max(255)
          //   .required('User Secret key is required'),
          // failed: Yup.string()
          //   .trim()
          //   .max(255)
          //   .required('User Secret key is required')
        })}
        onSubmit={(values) => {
          handleRoute(values);
          // navigate('/app/dashboard', { replace: true });
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          touched,
          values
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <TextField
                error={Boolean(touched.route && errors.route)}
                fullWidth
                helperText={touched.route && errors.route}
                label="Route"
                margin="dense"
                name="route"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.route}
                variant="outlined"
                size="small"
              />
              <TextField
                error={Boolean(touched.datafull && errors.datafull)}
                fullWidth
                helperText={touched.datafull && errors.datafull}
                label="Cost"
                margin="dense"
                name="datafull"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.datafull}
                variant="outlined"
                size="small"
              />
              {/* <TextField
                error={Boolean(touched.dataless && errors.dataless)}
                fullWidth
                helperText={touched.dataless && errors.dataless}
                label="Incomplete Fetch Cost "
                margin="dense"
                name="dataless"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.dataless}
                variant="outlined"
                size="small"
              />
              <TextField
                error={Boolean(touched.failed && errors.failed)}
                fullWidth
                helperText={touched.failed && errors.failed}
                label="Failed Fetch Cost"
                margin="dense"
                name="failed"
                onBlur={handleBlur}
                onChange={handleChange}
                type="text"
                value={values.failed}
                variant="outlined"
                size="small"
              /> */}
            </DialogContent>
            <DialogActions>
              <Button size="small" variant="outlined" onClick={handleClose}>
                Close
              </Button>
              <Button
                disabled={loading}
                variant="contained"
                color="primary"
                type="submit"
                size="small"
              >
                {loading && <CircularProgress size="1.5rem" />}
                &nbsp; Update Route
              </Button>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}

export default UpdateRoute;
